import { render, staticRenderFns } from "./Talent.vue?vue&type=template&id=0243cd90&scoped=true"
import script from "./Talent.vue?vue&type=script&lang=ts"
export * from "./Talent.vue?vue&type=script&lang=ts"
import style0 from "./Talent.vue?vue&type=style&index=0&id=0243cd90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243cd90",
  null
  
)

export default component.exports